// extracted by mini-css-extract-plugin
export default {"container":"ListVariations_container__Pz+2L","gridTable":"ListVariations_gridTable__spn-e","divider":"ListVariations_divider__RxFhs"};